import React from 'react';
import Slider from 'react-slick';
import { Button } from '../../Atoms';
import { useNavigate, Link } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';
import { FaBuilding, FaCarSide, FaChargingStation } from "react-icons/fa";
import { HashLink } from 'react-router-hash-link';
import DcController from '../../Assets/products_landing/DC Controller.png'
import AC1 from '../../Assets/products_landing/verycon_1-c.webp'
import AC2 from '../../Assets/products_landing/verycon_2-c.webp'
import AC3 from '../../Assets/products_landing/verycon_pro-c.webp'
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';


const ControllersSection = () => {
    const navigate = useNavigate();
    return (
        <section className="blade-padding-top containers-min mx-auto">
            <div className="px-4 z-40">
                {/* Title & Description */}
                <div className="mb-12 text-start">
                    <h4 className='font-gilroy'>AC and DC charger controller for complete range of products </h4>
                    <p className="text-base sm:text-lg md:text-xl font-light text-lighyGray mt-4 font-poppins">
                        Our controllers are made in-house at our India facility unit. They meet global certification standards.
                        They can be used to build AC or DC chargers within the following range
                    </p>
                </div>

                {/* Bullet Points */}
                {/* <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-10 text-lg sm:text-xl font-bold mb-10">
                    <ul className="list-disc pl-5 text-center sm:text-left">
                        <li>30 kW to 480 kW DC</li>
                    </ul>
                    <ul className="list-disc pl-5 text-center sm:text-left">
                        <li>7 kW to 44 kW AC</li>
                    </ul>
                </div> */}

                {/* Device Cards Section */}
                <div className=" p-6 rounded-xl">
                    <div className="flex flex-col lg:flex-row justify-between items-center gap-10 px-4">
                        {/* Left Column - DC Device */}
                        <div className="w-full lg:w-1/4 flex flex-col items-center">
                            <div className='pb-4 border-x border-y-0 md:border-y md:border-x-0 border-verde rounded-xl'>
                                <img src={DcController} alt="Verycon DC Pro" className="w-40 sm:w-48 object-contain mb-2" />
                                <p className="text-lg font-semibold text-verde text-center font-poppins">Verycon DC Pro</p>
                            </div>
                            <span className="text-sm text-gray-600 pt-2 mb-4 text-center w-full font-poppins">
                                30 kW to 480 kW
                            </span>
                        </div>

                        {/* Right Column - AC Devices */}
                        <div className="w-full lg:w-3/4 flex flex-col items-center">

                            <div className="w-full flex flex-col sm:flex-row justify-around gap-6 pb-4 border-x border-y-0 md:border-y md:border-x-0 border-verde rounded-xl">
                                <div className="flex flex-col items-center">
                                    <img src={AC2} alt="Verycon 2.0" className="w-36 sm:w-44 object-contain mb-2" />
                                    <p className="text-lg font-semibold text-verde text-center font-poppins">Verycon 2.0</p>
                                </div>
                                <div className="flex flex-col items-center">
                                    <img src={AC3} alt="Verycon Pro" className="w-36 sm:w-44 object-contain mb-2" />
                                    <p className="text-lg font-semibold text-verde text-center font-poppins">Verycon Pro</p>
                                </div>
                            </div>
                            <span className="text-sm text-gray-600 pt-2 mb-4 text-center w-full font-poppins">
                                7 kW to 44 kW
                            </span>
                        </div>
                    </div>
                </div>


                {/* CTA Button */}
                <div onClick={() => navigate('/controllers#controllers')}>
                    <button
                        className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                    >
                        <span className="flex justify-center items-center">
                            <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                            <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                        </span>
                        Explore Controllers
                    </button>
                </div>
            </div>
        </section>

    );
};

export default ControllersSection;
